import { observable, action, computed } from 'mobx';

export default class StationImageStore {
  @observable latestImages = [];
  @observable isLoading = false;
  
  albumOptions = [
    { name: 'All' },
    { name: 'Runway' },
    { name: 'Panoramic' },
    { name: 'North' }
  ]

  api;
  stationStore;

  constructor(transportLayer, stationStore) {
    this.api = transportLayer;
    this.stationStore = stationStore;
  }

  @action fetchLatestImages = async (album) => {
    this.latestImages = [];
    this.isLoading = true;
    try {
      const latestImages = await this.api.fetchLatestImages(album);

      let latestImagesWithStation = latestImages.reduce((acc, image) => {
        const station = this.stationStore.findById(image.station_id);
        if (!!station && !!station.latitude && !!station.longitude) {
          acc.push({
            ...station,
            ...image,
          });
        }
        return acc;
      }, []);

      this.latestImages = latestImagesWithStation;
      this.isLoading = false;
      return latestImages;
    } catch (e) {
      this.isLoading = false;
      return e;
    }
  }

  @action searchImage = payload => {
    return this.api.searchImage(payload);
  }
}


// WEBPACK FOOTER //
// ./src/stores/ImageStore.js